import { createSelector } from 'reselect'
import { getEntities, getAlarms as getAlarmsEntities } from './entities'
import { denormalize } from 'normalizr'
import * as schemas from '../../schemas'

export const getAlarmsRaw = createSelector([getEntities, getAlarmsEntities], (entities, alarms) => {
  alarms = alarms.map(a => {
    return a
  })
  return denormalize(alarms, [schemas.alarm], entities)
})
